import React from 'react'
import {useTranslation} from "react-i18next"

import {IonButtons, IonItem, IonItemOptions, IonLabel} from "@ionic/react"

import {Person as ItemType}     from "../../types/Person"
import ListItemOptionDelete     from "../People/ListItemOptionDelete"
import IconPerson               from "../common/Icons/Person"

import ListItemButtonDataSource from "../common/Buttons/ListItemButtonDataSource";
import ListItemButtonAlertEmail from "./ListItem/ButtonAlertEmail";
import ListItemButtonAlertPhone from "./ListItem/ButtonAlertPhone";
import ListItemButtonKeys       from "./ListItem/ButtonKeys";
import {useLockingSystems}      from "../../contexts/LockingSystemContext";

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {

    const {hasFeature: hasLockingSystemFeature} = useLockingSystems()

    const minButtonWidth: string = '50px'
        , {t} = useTranslation()

    return (
        <>
            <IonItem button detail routerLink={"/people/" + item.id + '/view'} slot="start">
                <IconPerson slot="start" />
                <IonLabel>
                    <h2>
                    {! item.firstName && ! item.lastName
                        ? <i>({t('common.no_name')})</i>
                        : item.firstName + ' ' + item.lastName}
                    {item.companyName &&
                        <span className="ion-hide-sm-down" style={{ 'fontWeight': 300 }}> - {item.companyName}</span>
                    }
                    </h2>
                    <h3 style={{ 'color': "#777" }}>
                        {item.email && <span className="ion-hide-sm-down">{item.email}</span>}
                        {item.email && item.phone1 && <span className="ion-hide-sm-down ion-color-primary">, </span>}
                        {item.phone1 && <span>{item.phone1}</span>}
                    </h3>
                </IonLabel>
                <IonButtons slot="end">
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <ListItemButtonKeys person={item} />
                    </span>
                    <div className="ion-hide-sm-down">
                        <span style={{ 'minWidth': minButtonWidth }}>
                            <ListItemButtonAlertPhone active={item.phone1 !== null && item.phone1 !== ''} />
                        </span>
                        <span style={{ 'minWidth': minButtonWidth }}>
                            <ListItemButtonAlertEmail active={item.email !== null && item.email !== ''} />
                        </span>
                        {hasLockingSystemFeature('HAS_DATA_SOURCES') === true &&
                        <span style={{ 'minWidth': '50px' }}>
                            <ListItemButtonDataSource active={item?.dataSourceId !== null}
                                                      itemType={t('people.title_item').toLowerCase()} />
                        </span>
                        }
                    </div>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {item.options?.isDeletable && <ListItemOptionDelete item={item} />}
            </IonItemOptions>
        </>
    )
}

export default ListItem